import React from "react";
import "./partners.css";
import Heading from "../Heading";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

const icon1 = "https://winpeforum.com/assets/elements/P3.png";
const icon3 = "https://winpeforum.com/assets/elements/La-Caisse.png";
const icon4 = "https://winpeforum.com/assets/elements/P5.png";
const icon5 = "https://winpeforum.com/assets/elements/P6.png";
const icon6 = "https://winpeforum.com/assets/elements/A91Logo.png";
const icon7 = "https://winpeforum.com/assets/elements/P7.png";
const icon8 = "https://winpeforum.com/assets/elements/P4.png";
const icon9 = "https://winpeforum.com/assets/elements/Sequoia_edit_Logo.png";
const icon10 = "https://winpeforum.com/assets/elements/sidbi_logo.png";
const icon11 = "https://winpeforum.com/assets/elements/multiplesnew.png";
const icon12 = "https://winpeforum.com/assets/elements/warburg_pincus_logo.png";
const icon13 = "https://winpeforum.com/assets/elements/IVCA_Logo.png";
const icon14 = "https://winpeforum.com/assets/elements/MegaDelta_Logo.png";
const icon15 = "https://winpeforum.com/assets/elements/Truenorthlogo1.png";
const icon16 =
  "https://winpeforum.com/assets/elements/GeneralAtlantic_logo.jpg";
const icon17 = "https://winpeforum.com/assets/elements/kkr_logo1_250x250.png";
const icon18 = "https://winpeforum.com/assets/elements/Apax_Logo.png";
const icon19 = "https://winpeforum.com/assets/elements/postkalaari.png";
const icon20 = "https://winpeforum.com/assets/elements/paragon.png";
const icon21 =
  "https://winpeforum.com/assets/elements/RRA_Logo_Blue_RGB_PNG.png";
const icon22 = "https://winpeforum.com/assets/elements/Arpwood_250x250.png";
const icon23 = "https://winpeforum.com/assets/elements/UN_Women_logo.png";
const icon24 = "https://winpeforum.com/assets/elements/CDC_logo.png";
const icon25 =
  "https://winpeforum.com/assets/elements/Advent_Logo.png";
const icon26 = "https://winpeforum.com/assets/elements/Investcorp-logo.png";

const icon27 = "https://winpeforum.com/assets/elements/IronPillar_Logo-021.png";

const icon28 = "https://winpeforum.com/assets/BX_BORDER_RGB-01.png";
const icon29 = "https://winpeforum.com/assets/elements/ChrysCapital.png";
const icon30 = "https://winpeforum.com/assets/elements/cppib.png";
const icon31 = "https://winpeforum.com/assets/elements/SupplyChainLabs.png";
const icon32 = "https://winpeforum.com/assets/elements/menterra.png";

const icon33= "https://winpeforum.com/assets/elements/trifecta.png"
const icon34= "https://winpeforum.com/assets/elements/fidelis.png"
const icon35= "https://winpeforum.com/assets/elements/niif.png"
const icon36= "https://winpeforum.com/assets/elements/aavishkaar1.png"
const icon37= "https://winpeforum.com/assets/elements/tpglogo.png"
const icon38= "https://winpeforum.com/assets/elements/BIInew.png"
const icon39= "https://winpeforum.com/assets/elements/motilalnew.png"
const icon40= "https://winpeforum.com/assets/elements/peakxv.png"
const icon41= "https://winpeforum.com/assets/elements/avishkaarcapital.png"
const icon42= "https://winpeforum.com/assets/elements/aavishkaar1.png"
const icon43= "https://winpeforum.com/assets/elements/bcg.png"
const icon44= "https://winpeforum.com/assets/elements/cxpartner.png"
const icon45= "https://winpeforum.com/assets/elements/endiya.png"
const icon46= "https://winpeforum.com/assets/elements/investcorp.png"
const icon47= "https://winpeforum.com/assets/elements/nucleus.png"
const icon48= "https://winpeforum.com/assets/elements/sidbi.png"
const icon49= "https://winpeforum.com/assets/elements/waterbridge.png"
const icon50= "https://winpeforum.com/assets/elements/proparco.png"
const icon51= "https://winpeforum.com/assets/elements/everstonenew.png"
const icon52= "https://winpeforum.com/assets/elements/pwclogo.png"
const icon53= "https://winpeforum.com/assets/elements/peer.png"
const icon54= "https://winpeforum.com/assets/elements/fireside.png"
const icon55= "https://winpeforum.com/assets/elements/iangroup.png"
const icon56= "https://winpeforum.com/assets/elements/waterfield.png"
const icon57= "https://winpeforum.com/assets/elements/sam.png"
const icon58= "https://winpeforum.com/assets/elements/bandp1.png"
const icon59= "https://winpeforum.com/assets/elements/alkemi1.png"
const icon60= "https://winpeforum.com/assets/elements/excellence.png"
const icon61= "https://winpeforum.com/assets/elements/sheffield.png"
const icon62= "https://winpeforum.com/assets/elements/ojif.png"
const icon63= "https://winpeforum.com/assets/elements/singularity.png"
const associatePartners = [
  {
    imgUrl: icon13,
    logoName: "partners logo",
    url: "https://ivca.in/",
  },
];

const knowledgePartners = [
  
  {
    imgUrl: icon42,
    logoName: "partners logo",
    url: "https://aavishkaarcapital.in/",
  },
   {
    imgUrl: icon25,
    logoName: "partners logo",
    url: "https://www.adventinternational.com/",
  },
  {
    imgUrl: icon59,
    logoName: "partners logo",
    url: "https://www.alkemivp.com/",
  },
  {
    imgUrl: icon22,
    logoName: "partners logo",
    url: "https://arpwood-partners.com/",
  },
  {
    imgUrl: icon43,
    logoName: "partners logo",
    url: "https://www.bcg.com/",
  },
  {
    imgUrl: icon28,
    logoName: "partners logo",
    url: "https://www.blackstone.com/",
  },
  {
    imgUrl: icon44,
    logoName: "partners logo",
    url: "https://www.cxpartners.in/",
  },
  {
    imgUrl: icon45,
    logoName: "partners logo",
    url: "https://www.endiya.com/",
  },
  {
    imgUrl: icon34,
    logoName: "partners logo",
    url: "https://www.fidelisworld.com/",
  },
 
  {
    imgUrl: icon16,
    logoName: "partners logo",
    url: "https://www.generalatlantic.com/",
  },
  {
    imgUrl: icon55,
    logoName: "partners logo",
    url: "https://iangroup.vc/",
  },
  {
    imgUrl: icon46,
    logoName: "partners logo",
    url: "https://www.investcorp.com/",
  },
  {
    imgUrl: icon32,
    logoName: "partners logo",
    url: "https://www.menterra.com/",
},
 {
    imgUrl: icon35,
    logoName: "partners logo",
    url: "https://www.niifindia.in/",
  },
{
  imgUrl: icon47,
  logoName: "partners logo",
  url: "https://www.nucleusofficeparks.com/",
},
{
  imgUrl: icon20,
  logoName: "partners logo",
  url: "http://www.paragonpartners.in/",
},
{
  imgUrl: icon53,
  logoName: "partners logo",
  url: "https://www.peercapital.in/",
},
{
  imgUrl: icon52,
  logoName: "partners logo",
  url: "https://www.pwc.in/",
},
  {
    imgUrl: icon21,
    logoName: "partners logo",
    url: "https://www.russellreynolds.com/",
  },
  {
    imgUrl: icon57,
    logoName: "partners logo",
    url: "https://www.amsshardul.com/",
  },
  {
    imgUrl: icon48,
    logoName: "partners logo",
    url: "https://www.sidbi.in/en",
  },
  {
    imgUrl: icon31,
    logoName: "partners logo",
    url: "https://supplychainlabs.in/",
  },
  {
    imgUrl: icon37,
    logoName: "partners logo",
    url: "https://tpg.com/",
  },
  {
    imgUrl: icon7,
    logoName: "partners logo",
    url: "https://www.trilegal.com/",
  },
   {
    imgUrl: icon15,
    logoName: "partners logo",
    url: "https://truenorth.co.in/",
  },
  {
    imgUrl: icon23,
    logoName: "partners logo",
    url: "https://www.unwomen.org/en",
  },
  {
    imgUrl: icon56,
    logoName: "partners logo",
    url: "https://waterfieldadvisors.com/",
  },

];

const pPartners = [
   
{
  imgUrl: icon54,
  logoName: "partners logo",
  url: "https://firesideventures.com/",
  },
  {
    imgUrl: icon39,
    logoName: "partners logo",
    url: "https://www.motilaloswal.com/",
  },
 {
    imgUrl: icon62,
    logoName: "partners logo",
    url: "https://oijif.com/",
  },
{
  imgUrl: icon50,
  logoName: "partners logo",
  url: "https://www.proparco.fr/en",
  },
{
  imgUrl: icon63,
  logoName: "partners logo",
  url: "https://singularityamc.com/",
  },
{
  imgUrl: icon33,
  logoName: "partners logo",
  url: "https://trifectacapital.in/",
  },

];

const iPartners = [
{
  imgUrl: icon60,
  logoName: "partners logo",
  url: "https://excellenceenablers.com/",
  },
{
  imgUrl: icon61,
  logoName: "partners logo",
  url: "https://www.sheffieldhaworth.com/",
  },   
{
  imgUrl: icon49,
  logoName: "partners logo",
  url: "https://waterbridge.vc/",
  },
];
const foundingPartners = [
  {
    imgUrl: icon6,
    logoName: "partners logo",
    url: "https://www.a91partners.com/",
  },
 
  {
    imgUrl: icon18,
    logoName: "partners logo",
    url: "https://www.apax.com/",
  },
  
  {
    imgUrl: icon1,
    logoName: "partners logo",
    url: "https://www.azbpartners.com/",
  },
  {
    imgUrl: icon58,
    logoName: "partners logo",
    url: "https://www.bharucha.in/",
  },
  {
    imgUrl: icon38,
    logoName: "partners logo",
    url: "https://www.bii.co.uk/en/",
  },
 
 
  {
    imgUrl: icon29,
    logoName: "partners logo",
    url: "http://www.chryscapital.com/",
  },
  {
    imgUrl: icon30,
    logoName: "partners logo",
    url: "https://www.cppinvestments.com/",
  },
  {
    imgUrl: icon51,
    logoName: "partners logo",
    url: "https://everstonecapital.com/",
  },

  {
    imgUrl: icon4,
    logoName: "partners logo",
    url: "http://www.gajacapital.com/",
  },
  
  
  {
    imgUrl: icon27,
    logoName: "Iron Pillar logo",
    url: "https://ironpillarfund.com/",
  },

 
  {
    imgUrl: icon17,
    logoName: "kkr logo",
    url: "https://www.kkr.com/",
  },
   {
    imgUrl: icon3,
    logoName: "partners logo",
    url: "https://www.lacaisse.com/en",
  },
  {
    imgUrl: icon5,
    logoName: "partners logo",
    url: "http://www.lhfunds.com/",
  },
  {
    imgUrl: icon14,
    logoName: "partners logo",
    url: "http://www.megadeltacapital.com/",
  },
  
  {
    imgUrl: icon11,
    logoName: "partners logo",
    url: "http://www.multiplesequity.com/",
  },
 
  {
    imgUrl: icon40,
    logoName: "partners logo",
    url: "https://www.peakxv.com/",
  },

 
 
 
  {
    imgUrl: icon12,
    logoName: "partners logo",
    url: "https://www.warburgpincus.com/",
  },
];

export class Partners extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};

    this.foundingPartners = [];

    this.Partners = [
      {
        imgUrl: icon36,
        logoName: "partners logo",
        url: "https://aavishkaarcapital.in/",
      },
      {
        imgUrl: icon25,
        logoName: "partners logo",
        url: "https://www.adventinternational.com/",
      },
      {
        imgUrl: icon18,
        logoName: "partners logo",
        url: "https://www.apax.com/",
      },
      {
        imgUrl: icon22,
        logoName: "partners logo",
        url: "https://arpwood-partners.com/",
      },
      {
        imgUrl: icon1,
        logoName: "partners logo",
        url: "https://www.azbpartners.com/",
      },
      {
        imgUrl: icon6,
        logoName: "partners logo",
        url: "https://www.a91partners.com/",
      },
      {
        imgUrl: icon24,
        logoName: "partners logo",
        url: "https://www.cdcgroup.com/",
      },
     
      {
        imgUrl: icon8,
        logoName: "partners logo",
        url: "https://www.everstonecapital.com/",
      },
      {
        imgUrl: icon4,
        logoName: "partners logo",
        url: "http://www.gajacapital.com/",
      },
      {
        imgUrl: icon16,
        logoName: "partners logo",
        url: "https://www.generalatlantic.com/",
      },
      {
        imgUrl: icon26,
        logoName: "partners logo",
        url: "https://www.investcorp.com/",
      },
      {
        imgUrl: icon27,
        logoName: "Iron Pillar logo",
        url: "https://ironpillarfund.com/",
      },
      {
        imgUrl: icon13,
        logoName: "partners logo",
        url: "https://ivca.in/",
      },
      {
        imgUrl: icon19,
        logoName: "partners logo",
        url: "https://www.kalaari.com/",
      },
      {
        imgUrl: icon17,
        logoName: "kkr logo",
        url: "https://www.kkr.com/",
      },
       {
        imgUrl: icon3,
        logoName: "partners logo",
        url: "https://www.lacaisse.com/en",
      },
      {
        imgUrl: icon5,
        logoName: "partners logo",
        url: "http://www.lhfunds.com/",
      },
      {
        imgUrl: icon14,
        logoName: "partners logo",
        url: "http://www.megadeltacapital.com/",
      },
      {
        imgUrl: icon32,
        logoName: "partners logo",
        url: "https://www.menterra.com/",
      },
    
      {
        imgUrl: icon11,
        logoName: "partners logo",
        url: "http://www.multiplesequity.com/",
      },
      {
        imgUrl: icon20,
        logoName: "partners logo",
        url: "http://www.paragonpartners.in/",
      },
      {
        imgUrl: icon21,
        logoName: "partners logo",
        url: "https://www.russellreynolds.com/",
      },
      {
        imgUrl: icon9,
        logoName: "partners logo",
        url: "https://www.sequoiacap.com/india/",
      },
   
      {
        imgUrl: icon7,
        logoName: "partners logo",
        url: "https://www.trilegal.com/",
      },
      {
        imgUrl: icon15,
        logoName: "partners logo",
        url: "https://truenorth.co.in/",
      },

      {
        imgUrl: icon12,
        logoName: "partners logo",
        url: "https://www.warburgpincus.com/",
      },
    ];
  }
  render() {
    return (
       
    <div className="section__content">
        <div className="partners__wrapper">
          <div className="partners__section">
            <div className="partners_content">
              <div className="low__heading"></div>
              <div className="">
                <Heading title="Partners in the cause" />
              </div>
              <ScrollAnimation
                delay={0}
                duration={3}
                animateIn="zoomIn"
                offset={300}
              >
                <div className="right_new_section">
                  <div className="right_content_new">
                    <div className="partners_logo_new">
                      <br />
                      <h3 className="partners-heading">
                       Mission Partners
                      </h3>
                      <div className="row justify-content-center">
                   
                      {foundingPartners.map((item, i) => {
                           
                          if(i>=0 && i<18    ) 
                          {
                            return ( 
            
                              <div
                                className=" col-md-2 col-sm-12 col-xs-12 col-lg-2"
                                key={i}
                              >
                                <div className="p_card" style={{  marginLeft: '0%'}}>
                                  <a
                                    href={item.url}
                                    target="__blank"
                                    className=""
                                  >
                                    <img
                                      src={item.imgUrl}
                                      alt={item.logoName}
                                      className="img-responsive"
                                      style={{width:'170px' }}
                                    />
                                  </a>
                                </div>
                              </div>
                            );
                          }     
                           
                           if(i==29) 
                           {
                            return ( 
                              <div
                              className="col-sm-12 col-xs-12 col-lg-2 col-md-2  "
                              key={i}
                            >
                              
                                <div className="p_card" style={{  marginRight: '0%'}}>
                                  <a
                                    href={item.url}
                                    target="__blank"
                                    className=""
                                  >
                                    <img
                                      src={item.imgUrl}
                                      alt={item.logoName}
                                      className="img-responsive"
                                      style={{width:'170px' }}
                                    />
                                  </a>
                                </div>
                              </div>  
                            );
                           }     
                          
                          return ( 
            
                            <div
                              className="col-md-4 col-sm-12 col-xs-12 col-lg-4"
                              key={i}
                            >
                              <div className="p_card">
                                <a
                                  href={item.url}
                                  target="__blank"
                                  className=""
                                >
                                  <img
                                    src={item.imgUrl}
                                    alt={item.logoName}
                                    className="img-responsive" style={{width:'140px' }}
                                  />
                                </a>
                              </div>
                            </div>
                          );
                        })}
                      </div>



                      <br />

<div className="row">
  <div className="col col-12 col-lg-12">
    <h3 className="partners-heading">
    Premium Partners 	
    </h3>
    <div className="row justify-content-center">
      {pPartners.map((item, i) => {
        return (
          <div className="col-md-2 col-sm-12 col-xs-12 col-lg-2 " key={i}>
            <div className="p_card" style={{  marginRight: '0%'}}>
              <a
                href={item.url}
                target="__blank"
                className=""
              >
                <img
                  src={item.imgUrl}
                  alt={item.logoName}
                  className="img-responsive  "   style={{width:'170px' }}
                />
              </a>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</div>
                      <br />




                      <br />

<div className="row">
  

  <div className="col col-12 col-lg-12">
    <h3 className="partners-heading">
    Initiative Partners
    </h3>
    <center><div className="row"  style={{width:'60%' }} >
     {iPartners.map((item, i) => {
        return (
          <div className="col-md-4 col-sm-12 col-xs-12 col-lg-4" key={i}>
            <div className="p_card" style={{  marginRight: '0%'}}>
              <a
                href={item.url}
                target="__blank"
                className=""
              >
                <img
                  src={item.imgUrl}
                  alt={item.logoName}
                  className="img-responsive  "   style={{width:'190px' }}
                />
              </a>
            </div>
          </div>
        );
      })}
    </div></center> 
  </div>
</div>
                      <br />

                      <div className="row">
                        

                        <div className="col col-12 col-lg-12">
                          <h3 className="partners-heading">
                          Others
                          </h3>
                          <div className="row">
                            {knowledgePartners.map((item, i) => {
                               if(i>=0 && i<24) {
                              return (
                                <div className="col-md-2 col-sm-12 col-xs-12 col-lg-2" key={i}>
                                  <div className="p_card" style={{  marginRight: '0%'}}>
                                    <a
                                      href={item.url}
                                      target="__blank"
                                      className=""
                                    >
                                      <img
                                        src={item.imgUrl}
                                        alt={item.logoName}
                                        className="img-responsive  "   style={{width:'170px' }}
                                      />
                                    </a>
                                  </div>
                                </div>
                              );}
                              else
                              {
                                 return (
                                <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12" key={i}>
                                  <div className="p_card" style={{  marginRight: '0%'}}>
                                    <a
                                      href={item.url}
                                      target="__blank"
                                      className=""
                                    >
                                      <img
                                        src={item.imgUrl}
                                        alt={item.logoName}
                                        className="img-responsive  "   style={{width:'170px' }}
                                      />
                                    </a>
                                  </div>
                                </div>
                              );
                              }
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
          <div className="section_divider">
            <img
              src="https://winpeforum.com/assets/elements/phone_section_divider.png"
              width="100%"
              alt="Section_divier_gray"
              className="img-responsive"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Partners;



// WEBPACK FOOTER //
// ./src/components/partners/index.js